module.exports = __webpack_public_path__ + "img/terroir-tinted-3-mobile.66627711.jpg";